<template>
<div class="chapter">
<div class="inner_page">
<p class="part-title"><span>BENICIA, CALIFORNIA</span></p>
<p class="part-suptitle"><span>Monday, February 27, 1995</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?544100f2